// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-qwixx-tsx": () => import("./../../../src/pages/qwixx.tsx" /* webpackChunkName: "component---src-pages-qwixx-tsx" */),
  "component---src-pages-sequencer-tsx": () => import("./../../../src/pages/sequencer.tsx" /* webpackChunkName: "component---src-pages-sequencer-tsx" */)
}

